
import { JwtStore } from '@/store/modules';
import { Component, Vue } from 'vue-property-decorator';

import QvInput from '@/components/FormComponents/QvInput.vue';
import { ValidationObserver } from 'vee-validate';

@Component({
  components: {
    ValidationObserver,
    QvInput
  },
  meta: {
    title: 'Forgot Password'
  }
})
export default class PasswordReset extends Vue {
  email = '';

  onSubmit() {
    if (this.email != '') {
      JwtStore.resetPassword({ email: this.email.toLowerCase() }).then(
        response => {
          if (response.message) {
            this.$q.notify({
              type: 'positive',
              message: `${response.message}`,
              timeout: 5000
            });
          }
        }
      );
    }
  }
}
